import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { curriculumType, ownershipStatusType, schoolType } from "../../../../../constants/common";
import ProfileForm from "../../../../../components/profile-form/profile-form";

const InstitutionInfo = ({ control, isEditMode }) => {
  return (
    <Row style={{ margin: "20px 0" }} gutter={[32, 16]}>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="institution_name"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="School Name"
              placeholder="Type School name"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="prinicipal_first_name"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="First Name of Principal/Head"
              required
              placeholder="Type first name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="prinicipal_middle_name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Middle Name of Principal/Head"
              placeholder="Type middle name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="prinicipal_last_name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Last Name of Principal/Head"
              placeholder="Type last name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="deputy_prinicipal_first_name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="First Name of Deputy Principal/Head"
              placeholder="Type first name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="deputy_prinicipal_middle_name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Middle Name of Deputy Principal/Head"
              placeholder="Type middle name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="deputy_prinicipal_last_name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Last Name of Deputy Principal/Head"
              placeholder="Type last name"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="registration_number"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Registration/ Accreditation Number"
              placeholder="Type registration/accreditation number"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="curriculum"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Select
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
              inputLabel="Curriculum"
              placeholder="--Select--"
              required
              isEdit={isEditMode}
            >
              {curriculumType?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </ProfileForm.Select>
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="school_type"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Select
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
              inputLabel="School Type"
              placeholder="--Select--"
              required
              isEdit={isEditMode}
            >
              {schoolType?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </ProfileForm.Select>
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="ownership_type"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Select
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
              inputLabel="Ownership Type"
              placeholder="--Select--"
              required
              isEdit={isEditMode}
            >
              {ownershipStatusType?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </ProfileForm.Select>
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="established_date"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.DatePicker
              value={
                field.value ? dayjs(field.value) : null
              }
              allowClear={false}
              isEdit={isEditMode}
              inputLabel="Date Established"
              placeholder="DD-MM-YYYY"
              onChange={field.onChange}
              status={error ? "error" : ""}
              prefix={
                <img
                  src="/assets/images/calendarOutlined.svg"
                  style={{ marginRight: 4 }}
                  alt="calendar"
                />
              }
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="vision"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Motto / Vision"
              placeholder="Type motto"
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="institution_logo"
          control={control}
          render={({ field }) => (
            <ProfileForm.Upload
              isEdit={isEditMode}
              inputLabel="Upload School Logo"
              value={field.value}
              handleBeforeUpload={(file) => {
                field?.onChange(file);
                return false;
              }}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default InstitutionInfo;
